import { useContext } from 'react'

import { type CollaborationsContext } from '../providers/CollaborationProvider.types'
import { collaborationsContext } from '../providers/CollaborationsProvider'

export const useCollaborations = (): CollaborationsContext => useContext(collaborationsContext)
